<template>
  <RadioGroup v-bind="$attrs">
    <RadioButton :key="i.value" :value="i.value" v-for="i in props.dicData">{{ i.label }}</RadioButton>
  </RadioGroup>
</template>

<script lang="tsx" setup name="SmartRadioButton">
import type { PropType } from 'vue'
import { RadioButton, RadioGroup } from 'ant-design-vue'

const props = defineProps({
  props: {
    type: Object as PropType<Record<any, any>>,
    default: () => ({
      label: 'label',
      value: 'value'
    })
  },
  options: {
    type: Array,
    default: () => []
  },
  dicData: {
    type: Array as PropType<Record<any, any>[]>,
    default: () => []
  }
})
</script>
